import { Representative } from "src/common/types/representative";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";

export default function serviceRepresentativesReducer(
  state: Representative[] = [],
  action: AnyAction
): Representative[] {
  switch (action.type) {
    case internalActionKeys.IMPORT_NEW_REPS_SUCCESS:
    case internalActionKeys.GET_BRANCH_REPRESENTATIVES_SUCCESS:
      return [...action.representatives.sort(repsCompareFunc)];
    case internalActionKeys.PATCH_BRANCH_REPRESENTATIVES_SUCCESS:
      return mergePatchedRep(state, action.representative);
    default:
      return state;
  }
}

export function repsCompareFunc(a: Representative, b: Representative) {
  if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
    return 1;
  } else if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
    return -1;
  } else {
    return 0;
  }
}

function mergePatchedRep(state: Representative[], patchedRep: Representative) {
  return [
    ...state.filter(r => r.id < patchedRep.id),
    { ...patchedRep },
    ...state.filter(r => r.id > patchedRep.id)
  ].sort(repsCompareFunc);
}
